import { type RecurrenceWhen } from '../../../../types'

export function parseRecurrenceWhen(recurrenceWhenId: string): RecurrenceWhen {
  const parsed = JSON.parse(recurrenceWhenId)
  if (!isRecurrenceWhen(parsed)) {
    throw new Error('Invalid RecurrenceWhen format')
  }

  return parsed
}
/**
 * Type guard to check if an object is a valid RecurrenceWhen
 */
function isRecurrenceWhen(obj: unknown): obj is RecurrenceWhen {
  if (typeof obj !== 'object' || obj === null) {
    return false
  }

  const candidate = obj as Record<string, unknown>

  // Check that type property exists and is a string
  if (typeof candidate.type !== 'string') {
    return false
  }

  // Validate based on the type discriminator
  switch (candidate.type) {
    case 'WEEKLY':
      return (
        typeof candidate.weekday === 'number' && Object.keys(candidate).length === 2 // Only 'type' and 'weekday'
      )

    case 'MONTHLY':
      return (
        typeof candidate.date === 'string' &&
        (candidate.cardinal === undefined || typeof candidate.cardinal === 'number') &&
        (candidate.weekday === undefined || typeof candidate.weekday === 'number') &&
        // Check that only expected properties exist
        Object.keys(candidate).every(key => ['type', 'date', 'cardinal'].includes(key))
      )

    case 'ANNUALLY':
      return (
        typeof candidate.date === 'string' &&
        (candidate.cardinal === undefined || typeof candidate.cardinal === 'number') &&
        (candidate.weekday === undefined || typeof candidate.weekday === 'number') &&
        (candidate.month === undefined || typeof candidate.month === 'number') &&
        // Check that only expected properties exist
        Object.keys(candidate).every(key =>
          ['type', 'date', 'cardinal', 'month', 'weekday'].includes(key),
        )
      )

    default:
      return false
  }
}
